import type { NavigateFunction, Location } from 'react-router-dom'

export type VerifyIdentityIntent = 'default' | 'create-biddle' | 'letter-claim'

/** Open the verify-identity modal over the current screen (keeps background location). */
export function openVerifyIdentity(
  navigate: NavigateFunction,
  location: Location,
  next?: string,
  intent: VerifyIdentityIntent = 'default',
) {
  const params = next ? `?next=${encodeURIComponent(next)}` : ''
  navigate(`/verify-identity${params}`, {
    state: { background: location, verifyIntent: intent },
  })
}
